import { BigNum, QUOTE_PRECISION_EXP } from '@drift-labs/sdk';
import { useTickedAccountData } from 'src/hooks/useAccountData';
import { useIsolatedPositionDepositsTotal } from 'src/hooks/useIsolatedPositionDepositsTotal';

export default function usePortfolioNetAccountValue() {
	const currentAccount = useTickedAccountData();
	const client = currentAccount?.client;
	const totalIsolatedDeposits = useIsolatedPositionDepositsTotal();

	if (!client?.isSubscribed) {
		return;
	}

	const value = client
		.getNetSpotMarketValue()
		.add(client.getUnrealizedPNL(true))
		.add(totalIsolatedDeposits);

	return BigNum.from(value, QUOTE_PRECISION_EXP);
}
